import View from './netx-view';
import _ from 'underscore';
import {performLegacyAction} from '@netx/core-actions';
import type AppView from '@netx/core-app/models/appView';
import type Collection from '@netx/core/lib/netx-collection';
import type Model from '@netx/core/lib/netx-model';

export {isBrandPortal, protectObjectProxy} from '../utils';

export const getViewModel = <TModel extends Model = Model>(
	view: View<TModel | AppView<TModel>>,
): TModel | undefined => {
	const viewData = view.data || {};
	let model = viewData.model || view.model;
	if (model && model.isAppView) {
		model = model.viewModel as TModel;
	}
	return !model ? undefined : (model as TModel);
};

export const getViewCollection = <TCollection extends Collection = Collection>(
	view: View<any, TCollection>,
): TCollection | undefined => {
	const viewData = view.data || {};
	const collection = viewData.collection || view.collection;
	return !collection ? undefined : (collection as TCollection);
};

export const performAction = performLegacyAction;

export const isTouchEnabled = () =>
	'ontouchstart' in window || navigator?.maxTouchPoints > 0;

export default {
	getViewCollection,
	getViewModel,
	performAction,
};
